import { tv } from 'tailwind-variants'

import { listboxStyles } from '@gto/ui/styles/listbox-styles'

export const selectVariants = tv({
  slots: {
    trigger: [
      'font-inter flex w-full cursor-pointer items-center justify-between transition-colors',
      'rounded-sm bg-components-input-filled-enabledFill text-text-secondary border border-solid border-transparent',
      'hover:bg-components-input-filled-hoverFill hover:text-text-primary',
      'focus-visible:outline-none focus-visible:bg-components-input-filled-enabledFill focus-visible:text-text-primary focus-visible:border-primary-main',
      'data-[popup-open]:bg-components-input-filled-enabledFill data-[popup-open]:text-text-primary data-[popup-open]:border-primary-main',
      'aria-[invalid=true]:border-error-main aria-[invalid=true]:text-text-primary aria-[invalid=true]:hover:border-error-main aria-[invalid=true]:focus-visible:border-error-main',
      'data-[disabled]:bg-components-input-filled-enabledFill data-[disabled]:text-text-disabled data-[disabled]:border-transparent data-[disabled]:cursor-default',
    ],
    value: 'truncate data-[placeholder]:text-text-secondary',
    icon: 'text-text-secondary shrink-0',
    positioner: listboxStyles.positioner,
    popup: listboxStyles.popup,
    list: listboxStyles.list,
    group: listboxStyles.group,
    groupLabel: listboxStyles.groupLabel,
    item: listboxStyles.item,
  },
  variants: {
    // `listboxStyles.popup` pins the popup to `w-[var(--anchor-width)]`, which wraps a long
    // option under a narrow trigger. `content` releases the width and keeps the anchor as a
    // floor. Kept here rather than in the shared `listbox-styles`, which Autocomplete and
    // `libs/pokerarena-ui` also read.
    width: {
      anchor: {},
      content: { popup: 'w-auto min-w-[var(--anchor-width)]' },
    },
    size: {
      small: {
        // The icon renders inside the trigger, so size its svg here — `Select.Icon`
        // is a standalone sub-component that never receives the `size` variant.
        trigger:
          'tracking-0.1 text-[14px] font-medium leading-[18px] h-8 px-2 py-1 gap-1 [&_svg]:size-4',
      },
      medium: {
        trigger:
          'tracking-0.15 text-[16px] font-normal leading-[24px] h-12 p-2 gap-1 [&_svg]:size-6',
      },
    },
  },
  defaultVariants: {
    size: 'small',
    width: 'anchor',
  },
})
